function getElementDimensionsCallback(element, callback) {
  const observer = new IntersectionObserver((entries, observer2) => {
    if (entries.length === 1) {
      callback(entries[0].boundingClientRect);
    } else {
      const entry = entries.find((entry2) => entry2.boundingClientRect.width > 0 || entry2.boundingClientRect.height > 0) || entries[0];
      callback(entry.boundingClientRect);
    }
    observer2.disconnect();
  });
  observer.observe(element);
}
function getElementDimensions(element) {
  return new Promise((resolve) => {
    getElementDimensionsCallback(element, resolve);
  });
}
export {
  getElementDimensions,
  getElementDimensionsCallback
};
//# sourceMappingURL=getElementDimensions.js.map
